import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.bereich-anlegen';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichAnlegenEffects {

    BereichAnlegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BEREICH_ANLEGEN),
        mergeMap((x: ac.PostBereichAnlegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBereichAnlegen(x.bereichRequest).pipe(
                map((result: any) => {
                    return new ac.PostBereichAnlegenErfolgreichAction(result, x.bereichRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBereichAnlegenFehlerAction(error, x.bereichRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VerwaltenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VerwaltenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VerwaltenCommandService);
        }
        return this.service;
    }
}
